import { render, staticRenderFns } from "./form_paper.vue?vue&type=template&id=48843b44"
import script from "./form_paper.vue?vue&type=script&lang=js"
export * from "./form_paper.vue?vue&type=script&lang=js"
import style0 from "./form_paper.vue?vue&type=style&index=0&id=48843b44&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports